import { imageFragment } from 'legacy/graphql/fragments/components/imageFragment';

/**
 * @type {String}
 */
export const lcMastheadFragment = `
... on SectionLearningCenterMasthead2 {
    sys {
      id
    }
    heading
    headingHighlight
    paragraph {
      json
    }
    searchInput
    background
    imagesCollection(limit: 2) {
      items {
        ${imageFragment}
      }
    }
  }
`;
